export default class CitizenInformationRequest {
  id: number;
  subject: string;
  description: string;
  type_request_id: number;
  user_id?: number;
  user?: User;
  entity_id: number;
  gender?: string;
  status_id?: number;
  attachments: CitizenInformationAttachment[];
  info_response?: CitizenInformationRequestResponse;
  created_at?: string;
  deleted_at?: string;
  status?: CitizenInformationStatus;
  type_request?: CitizenInformationType;

  constructor(values: CitizenInformationRequestConstructorValues) {
    this.id = values.id;
    this.subject = values.subject;
    this.description = values.description;
    this.type_request_id = values.type_request_id;
    this.user_id = values.user_id;
    this.user = values.user;
    this.gender = values.gender;
    this.entity_id = values.entity_id;
    this.status_id = values.status_id;
    this.attachments = values.attachments;
    this.info_response = values.info_response;
    this.created_at = values.created_at;
    this.deleted_at = values.deleted_at;
    this.status = values.status;
    this.type_request = values.type_request;
  }
}

export interface CitizenInformationRequestConstructorValues {
  id: number;
  subject: string;
  gender?: string;
  description: string;
  type_request_id: number;
  user_id?: number;
  user?: User;
  entity_id: number;
  status_id?: number;
  attachments: CitizenInformationAttachment[];
  info_response?: CitizenInformationRequestResponse;
  created_at?: string;
  status?: CitizenInformationStatus;
  type_request?: CitizenInformationType;
  deleted_at?: string;
}

export interface CitizenInformationRequestResponse {
  id?: number;
  description: string;
  status_id: number;
  attachments: CitizenInformationAttachment[];
  created_at: string;
  updated_at: string;
}
export interface CitizenInformationAttachment {
  id: number;
  name: string;
  download_url: string;
}

export interface User {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  personal_identification: string;
  age: string;
  gender: string;
  township: string;
  urbanization: string;
  territorial_division?: TerritorialDivision;
}

export interface TerritorialDivision {
  province: string;
  district: string;
  township: string;
}

export interface CitizenInformationType {
  id: number;
  name: string;
}
export interface CitizenInformationStatus {
  id: number;
  name: string;
}

export enum StatusId {
  PREVIUS_PHASE_ID = 1,
  IN_PROCESS_ID = 2,
  RESOLVED_ID = 3,
  DENIED_ID = 4,
}
